


//统一方法来和app通讯
function callappfunc(fname,data,callback,justback=false,justcall=false){
  let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
  let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

  window[fname]=callback;


  if(isAndroid){
    try{
        window.AndroidWebView[fname](data);
    }catch(err){
      callback(false)
      console.log(err)
    }

  }
  if(isiOS){
      try{
          window.webkit.messageHandlers[fname].postMessage(data);
      }catch(err){
       callback(false);
        console.log(err)
      }

  }
}


export default callappfunc;



// WEBPACK FOOTER //
// ./src/utils/jstoapp.js